import { styled } from "styled-components";

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: var(--container-min-height);
  position: relative;
`;

export default AppContainer;
